export default __webpack_public_path__ + "static/16_29-2eae93670e7052ab190db134bd1d3f09.png";